// extracted by mini-css-extract-plugin
export default {"screensSkeleton":"screensSkeleton_screensSkeleton__MglLl","skeletonStyles":"screensSkeleton_skeletonStyles__Ezp4g"};